//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Qp_Qs',
  data() {
    return {
      defaultJson: {
        "PV_hint": "肺静脉氧饱和度。如果不输入该数值，则默认为 98% - 100%。",
        "Sat. Aorta": "主动脉氧饱和度",
        "Qp:Qs": "Qp:Qs",
        "MV_hint": "混合静脉氧饱和度。实际操作中经常使用上腔静脉氧饱和度。",
        "Sat. Pulm. Artery": "肺动脉氧饱和度",
        "Ao_hint": "体循环动脉氧饱和度，通过 ABG 测得。",
        "PA_hint": "肺动脉氧饱和度，通过 Swan-Ganz 漂浮导管的远端官腔测得。",
        "Sat. Mixed Venous": "混合静脉氧饱和度",
        "Sat. Pulm. Vein": "肺静脉氧饱和度"
      },
      form: {
        satao: '',
        satmv: '',
        satpv: '',
        satpa: '',
      },
      UACresult: '--',
      hasScore: false,
      disabled: false,
      int_score: 0
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        self.UACresult = '--'
        return '--'
      } else {
        // (satao - satmv) / (satpv - satpa)
        let result = (form.satao - form.satmv) / (form.satpv - form.satpa)
        self.hasScore = true
        return String(result.toFixed(1))
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/QpQs.vue